var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburguerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 3.5,
    width: 16,
    height: 3,
    rx: 1.5,
    transform: "rotate(-180 16.5 3.5)",
    stroke: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 19.5,
    width: 20,
    height: 3,
    rx: 1.5,
    transform: "rotate(-180 20.5 19.5)",
    stroke: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 11.5,
    width: 23,
    height: 3,
    rx: 1.5,
    transform: "rotate(-180 23.5 11.5)",
    stroke: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburguerMenu);
export default __webpack_public_path__ + "static/media/hamburguer_menu.8fb73fae0658263977c12973f1fa712f.svg";
export { ForwardRef as ReactComponent };